import { Button, Card, Col, Modal, Row, Table } from "antd";
import React, { useState } from "react";

const CustomTable = ({ list }) => {
	const columns = [
		{
			title: "Name",
			dataIndex: "product",
			key: "product",
			render: (product) => product?.name,
		},
		{
			title: "Product Quantity",
			dataIndex: "product_quantity",
			key: "product_quantity",
		},
		{
			title: "Product Unit Price ",
			dataIndex: "product_purchase_price",
			key: "product_purchase_price",
		},
		{
			title: "Discount (%)",
			dataIndex: "product_discount",
			key: "product_discount",
			render: (value, record) => value ?? record.product_purchase_discount ?? 0,
		},
		{
			title: "Total Amount",
			dataIndex: "",
			render: ({
				product_quantity,
				product_purchase_price,
				product_discount,
				product_purchase_discount,
			}) => {
				const qty = Number(product_quantity || 0);
				const price = Number(product_purchase_price || 0);
				const gross = qty * price;
				const pct = Number(product_purchase_discount ?? product_discount ?? 0);
				const disc = (gross * pct) / 100;
				return gross - disc;
			},
		},
	];
	const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
  const filtered = (list || []).filter((i) => Number(i.product_quantity || 0) > 0);

	return (
		<Row>
			<Col span={24} className='mt-2'>
				<Card
					className='header-solid h-full'
					bordered={false}
					bodyStyle={{ paddingTop: "0" }}>
					<div className='col-info'>
						<Table
							loading={!list}
							columns={columns}
							dataSource={filtered ? addKeys(filtered) : []}
						/>
					</div>
				</Card>
			</Col>
		</Row>
	);
};

const ReturnPurchaseInvoiceProductList = ({ list }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const showModal = () => {
		setIsModalOpen(true);
	};

	const handleOk = () => {
		setIsModalOpen(false);
	};

	const handleCancel = () => {
		setIsModalOpen(false);
	};

	return (
		<>
			<button className='btn btn-primary btn-sm' onClick={showModal}>
				view
			</button>
			<Modal
				width={1000}
				title={`View Details of Product`}
				open={isModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}>
				<CustomTable list={list} />
				<div className='text-start ms-3'>
					<h6>
						Total Quantity:{"  "}{" "}
						<strong>
							{list
								?.filter((i) => Number(i.product_quantity || 0) > 0)
								.reduce((acc, item) => acc + Number(item.product_quantity || 0), 0)}
						</strong>
					</h6>
					<h6>
						Total Amount:{"  "}{" "}
						<strong>
							{list
								?.filter((i) => Number(i.product_quantity || 0) > 0)
								.reduce((acc, item) => {
									const qty = Number(item.product_quantity || 0);
									const price = Number(item.product_purchase_price || 0);
									const gross = qty * price;
									const pct = Number(
										item.product_purchase_discount ?? item.product_discount ?? 0
									);
									const disc = (gross * pct) / 100;
									return acc + (gross - disc);
								}, 0)}
						</strong>
					</h6>
				</div>
			</Modal>
		</>
	);
};

export default ReturnPurchaseInvoiceProductList;
